// Assets Section - Work-in-progress asset library (coming soon)
// Follows the Section, Component & Manager System architecture

import { MainLayout } from '../../components/Layout';
import { logger, useManager } from '../../core';
import { AssetsManager } from './managers/assets-manager';
import { AssetsComingSoon } from './components';
import './AssetsSection.css';

export function AssetsSection() {
  const { isInitialized } = useManager(AssetsManager);

  if (!isInitialized) {
    return (
      <MainLayout contentClassName="main-content--assets">
        <div className="assets-container">
          <div className="assets-panel">
            <div style={{ color: '#999' }}>Loading assets...</div>
          </div>
        </div>
      </MainLayout>
    );
  }

  logger.log(
    { tags: 'section|assets|render', color1: 'lime' },
    'AssetsSection rendering'
  );

  return (
    <MainLayout contentClassName="main-content--assets">
      <div className="assets-container">
        <AssetsComingSoon />
      </div>
    </MainLayout>
  );
}
